var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-white margin-top-xs padding border-radius tree-div"},[_c('el-tree',{attrs:{"data":_vm.treeData,"props":_vm.defaultProps,"default-expand-all":""},on:{"node-click":_vm.handleNodeClick}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }